<template>
  <div class="container">
    
    <div class="row">
      <div class="col-12">
        <div class="products-title">
          Supported Models
	</div>
	<div class="d-flex align-items-start justify-content-center" style="height: auto;">
	  <EasyDataTable
	    table-class-name="custom"
	    style="width: 100%;"
	    v-model:server-options="serverOptions"
	    :server-items-length="serverItemsLength"
	    :loading="loading"
	    :headers="headers"
	    :items="items"
	      :body-row-class-name="bodyRowClassNameFunction"
	    :rowsItems=[10,20,50]
	    :mustSort=true
	    @click-row="selectFirmwareInfo"
	    border-cell>
	    <template #item-status="item">
	      <span v-if="item.status==0">In Test <button type="releasebtn" @click="release" v-bind::data-id="item.id">Release</button></span>
	      <span v-else>In Operation</span>
	    </template>
          </EasyDataTable>
	</div>
      </div>
    </div>
  </div>

  <div class="container mt-4 mb-4">
    <form>
      <div class="card">
	<div class="card-header text-left">Latest Version Info</div>
        <div class="card-body">
          <div class="form-group row">
            <label for="select2" class="col-sm-3 col-form-label">Model Name</label>
            <div class="col-sm-7 text-left">
              <select class="custom-select size-select1 form-control" id="select1" v-model="model_id" @change="changeModelId">
                <option selected></option>
		<option v-for="option in model_list" :value="option.model_id">
		  {{ option.model_name }}
		</option>
              </select>
            </div>
            <div class="col-sm-2 text-right">
	      <router-link to="./model.html">
		<div class="bluebtn2" style="margin: 1px auto;">Edit</div>
	      </router-link>
            </div>
          </div>
          <div class="form-group row">
            <label for="select2" class="col-sm-3 col-form-label">Status</label>
            <div class="col-sm-9 text-left pad-4">
	      {{ disp_status }}
            </div>
          </div>

          <div class="form-group row">
            <label for="latest-version" class="col-sm-3 col-form-label">Latest Version</label>
            <div class="col-sm-5 form-inline pad-4">
              <input type="text" class="form-control" id="latest-version" name="latest-version" v-model="latest_version" maxlength="12">
            </div>
          </div>
          <div class="form-group row">
            <label for="japan-url" class="col-sm-3 col-form-label">Download Web Site (Japanese)</label>
            <div class="col-sm-7 pad-4">
              <input type="text" class="form-control" id="japan-url" name="japan-url" v-model="ja_download_web">
            </div>
          </div>
          <div class="form-group row">
            <label for="english-url" class="col-sm-3 col-form-label">Download Web Site (English)</label>
            <div class="col-sm-7 pad-4">
              <input type="text" class="form-control" id="english-url" name="english-url" v-model="en_download_web">
            </div>
          </div>
          <div class="form-group row">
            <label for="direct-url" class="col-sm-3 col-form-label">Direct Download URL</label>
            <div class="col-sm-7 pad-4">
	    {{direct_download_url}}
            </div>
            <div class="col-sm-2 text-right">
	      <label class="bluebtn2" v-bind:class="upload_btnclass" style="margin: 1px auto;">
		Upload
		<input id="upload" type="file" style="display:none;" accept=".x" @change="upload" v-bind:disabled="disable_upload" />
	      </label>
            </div>
          </div>
          <div class="form-group row">
            <label for="file-size" class="col-sm-3 col-form-label">File Size (byte)</label>
            <div class="col-sm-7 pad-4">
	    {{file_size}}
            </div>
            <div class="col-sm-2 text-right">
	      <button type="button" class="bluebtn2" style="margin: 1px auto;" @click="remove" v-bind:disabled="disable_remove">Remove</button>
            </div>
          </div>
          <div class="form-group row">
            <label for="hash-value" class="col-sm-3 col-form-label">Hash Value (SHA-1)</label>
            <div class="col-sm-7 pad-4">
	    {{hash_value}}
            </div>
          </div>

          <div class="form-group row">
            <label for="release-date" class="col-sm-3 col-form-label">Release Date (JST)</label>
	    <datepicker
	      class="col-sm-4 form-inline pad-4"
	      v-model="release_date"
	      />
          </div>

          <div class="form-group row">
            <label for="tel1" class="col-sm-3 col-top-label">Release Note</label>
            <div class="col-sm-9 form-inline pad-4">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-9" style="padding-left: 0">
                    <div class="form-group">
                      <textarea class="form-control" style="width: 100%; height: 200px;" id="exampleFormControlTextarea1" rows="3" v-model="release_note"></textarea>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="container-fluid">
                      <div class="row">
                        <div class="centerbox"><button type="button" class="bluebtn1" @click="add" v-bind:disabled="disable_add">Add</button></div>
                      </div>
                      <div class="row">
                        <div class="centerbox"><button type="button" class="bluebtn1" @click="update" v-bind:disabled="disable_update">Update</button></div>
                      </div>
                      <div class="row">
                        <div class="centerbox"><button type="button" class="bluebtn1" @click="del" v-bind:disabled="disable_update">Delete</button></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <p class="linespace20"></p>
    <div class="text-right">
      <router-link to="./menu.html">
	<div class="greenbtnM">Close</div>
      </router-link>
    </div>
  </div>

  <ConfirmDialog />
  <ErrorDialog />
  <LoadingDialog />
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import { checkMaintenance, getFirmwareInfo, getFirmwareList, addFirmwareInfo, updateFirmwareInfo, deleteFirmwareInfo, getModelList, uploadFirmware, createSession, updateSession, releaseFirmware, removeFirmware, wait } from '../server';
import { error } from './ErrorDialog.vue';
import { confirm, confirmRemove, confirmUpload, confirmRelease } from './ConfirmDialog.vue';
import { startLoading, stopLoading } from './LoadingDialog.vue';

checkMaintenance();

const headers = [
    {
	text: 'Model Name',
	value: 'model_name',
	sortable: true
    },
    {
	text: 'Status',
	value: 'status',
	sortable: true
    },
    {
	text: 'Latest Version',
	value: 'latest_version',
	sortable: true
    },
    {
	text: 'Download Web Site (Japanese)',
	value: 'ja_download_web',
	sortable: true
    },
    {
	text: 'Download Web Site (English)',
	value: 'en_download_web',
	sortable: true
    },
    {
	text: 'Direct Download URL',
	value: 'direct_download_url',
	sortable: true
    }
];

const items = ref([]);

const loading = ref(false);
const serverItemsLength = ref(0);
const serverOptions = ref({
    page: 1,
    rowsPerPage: 10,
    sortBy: 'model_name',
    sortType: 'asc'
});

const loadFromServer = async() => {
    loading.value = true;
    try {
	let res = await getFirmwareList(serverOptions.value);
	items.value = res.serverCurrentPageItems;
	serverItemsLength.value = res.serverTotalItemsLength;
    }
    catch(e) {
	console.log(e)
    }
    finally {
	loading.value = false;
    }
};

loadFromServer();

watch(serverOptions, (value) => {loadFromServer(); }, { deep: true });

const model_list = ref([]);

const loadModelsFromServer = async() => {
    try {
	let res = await getModelList(0);
	model_list.value = res.serverCurrentPageItems.reverse();
	
    }
    catch(e) {
	console.log(e)
    }
};

loadModelsFromServer();

const firmware_id         = ref(0);
const model_id            = ref(0);
const status              = ref(0);
const latest_version      = ref('');
const ja_download_web     = ref('');
const en_download_web     = ref('');
const direct_download_url = ref('');
const file_id             = ref(null);
const file_id_org         = ref(null);
const file_size           = ref('');
const hash_value          = ref('');
const release_date        = ref('');
const release_note        = ref('');

const disable_upload = ref(true);
const disable_remove = ref(true);
const disable_add    = ref(true);
const disable_update = ref(true);

const session_id     = ref(false);
const mounted        = ref(false);

const disp_status = computed( () => {
    if (firmware_id.value == 0) {
      return '-----';
    }
    return status.value == 0 ? 'In Test' : 'In Operation';
});

const upload_btnclass = computed( () => {
    return disable_upload.value ? 'disabled' : '';
});

const upload = async() => {
    const fileInput = document.getElementById('upload');
    const files = fileInput.files;
    const filename = files[0].name;
    let modelname = '######';
    model_list.value.find((model)=>{
        if (model.model_id == model_id.value) {
	    modelname = model.model_name;
	    return true;
	}
    })
    const reg1 = new RegExp(modelname);
    const reg2 = new RegExp(latest_version.value.replace('.',''));
    if (!filename.match(reg1) || !filename.match(reg2)) {
        confirmUpload(realUpload, () => {
	    fileInput.value = '';
	});
    } else {
        await realUpload();
    }
}

const realUpload = async () => {
    const fileInput = document.getElementById('upload');
    const files = fileInput.files;
    try {
        startLoading();
        let res = await uploadFirmware(session_id.value,model_id.value,latest_version.value,files[0]);
	stopLoading();
        if (res.data.result == 'ok') {
            file_id.value             = res.data.file_id;
            file_id_org.value         = res.data.file_id;
            direct_download_url.value = res.data.url;
            file_size.value           = res.data.size;
            hash_value.value          = res.data.sha1;
    	    disable_remove.value      = false;
        }
    } catch(e) {
        error('Upload failed.')
    }
    fileInput.value = '';
};

const remove = async() => {
    confirmRemove(realRemove);
};

const realRemove = async() => {
    //let res = await removeFirmware(session_id.value,file_id.value,firmware_id.value);
    //await loadFromServer();
    file_id.value             = null;
    direct_download_url.value = '';
    file_size.value           = '';
    hash_value.value          = '';
    disable_remove.value      = true;
};

const release = async(ev) => {
    ev.stopPropagation();
    let id = ev.target.getAttribute(":data-id");
    let res = await getFirmwareInfo({firmware_id:id});
    confirmRelease(ev,res.data.model_name,res.data.latest_version,realRelease);
}

const realRelease = async(ev) => {
    try {
        let id = ev.target.getAttribute(":data-id");
        await releaseFirmware(id);
        disable_upload.value = true;
        disable_remove.value = true;
        await loadFromServer();
	let res = await getFirmwareInfo({firmware_id:id});
	if (res.data) {
	  await selectFirmwareInfo(res.data);
	}
    } catch(e) {
        console.log(e)
    }
};

const add = async () => {
    if (!model_id.value) {
	error('Model Name is empty');
	return;
    }
    if (!latest_version.value) {
	error('Latest Version is empty');
	return;
    }
//    if (!ja_download_web.value) {
//	error('Download Web Site2 (Japanese) is empty');
//	return;
//    }
//    if (!en_download_web.value) {
//	error('Download Web Site2 (English) is empty');
//	return;
//    }
//    if (!release_date.value) {
//	error('Release Date is empty');
//	return;
//    }
    let firmwareInfo = {
	model_id:        model_id.value,
	status:          '0', // TODO
	latest_version:  latest_version.value,
	ja_download_web: ja_download_web.value,
	en_download_web: en_download_web.value,
	file_id:         file_id.value,
	release_date:    release_date.value,
	release_note:    release_note.value,
	session_id:      session_id.value
    };
    
    loading.value = true;
    try {
	let res = await addFirmwareInfo(firmwareInfo, serverOptions.value);
	await loadFromServer();
	if (res.data) {
	    await selectFirmwareInfo(res.data.data);
	}
    }
    catch(e) {
	console.log(e)
    }
    finally {
	loading.value = false;
    }
    disable_add.value      = true;
    disable_update.value   = false;
    disable_upload.value   = false;
    if (file_id.value == null) {
        disable_remove.value = true;
    } else {
        disable_remove.value = false;
    }
};

const update = async () => {
    if (!model_id.value) {
	error('Model Name is empty');
	return;
    }
    if (!latest_version.value) {
	error('Latest Version is empty');
	return;
    }
/*    
    if (!ja_download_web.value) {
	error('Download Web Site (Japanese) is empty');
	return;
    }
    if (!en_download_web.value) {
	error('Download Web Site (English) is empty');
	return;
    }
    if (!release_date.value) {
	error('Release Date is empty');
	return;
    }
*/
    let firmwareInfo = {
	latest_version:  latest_version.value,
	ja_download_web: ja_download_web.value,
	en_download_web: en_download_web.value,
	file_id:         file_id.value,
	release_date:    release_date.value,
	release_note:    release_note.value,
	firmware_id:     firmware_id.value,
	session_id:      session_id.value
    };
    
    loading.value = true;
    try {
        let res;
        if (file_id_org.value != null && file_id.value == null) {
            res = await removeFirmware(session_id.value,file_id.value,firmware_id.value);
	}
	res = await updateFirmwareInfo(firmwareInfo, serverOptions.value);
	await loadFromServer();
    }
    catch(e) {
	console.log(e)
    }
    finally {
	loading.value = false;
    }
};

const del = () => {
    confirm(realDel)
};

const realDel = async () => {
    loading.value = true;
    try {
	let res = await deleteFirmwareInfo(session_id.value,firmware_id.value);
	await loadFromServer();
    }
    catch(e){
	console.log(e)
    }
    finally {
	loading.value = false;
    }

    firmware_id.value         = 0;
    model_id.value            = 0;
    status.value              = 0;
    latest_version.value      = '';
    ja_download_web.value     = '';
    en_download_web.value     = '';
    file_id.value             = null;
    file_id_org.value         = null;
    direct_download_url.value = '';
    file_size.value           = '';
    hash_value.value          = '';
    release_date.value        = '';
    release_note.value        = '';

    disable_add.value    = true;
    disable_update.value = true;
    disable_upload.value = true;
    disable_remove.value = true;
};

const selectFirmwareInfo = async (data) => {
    firmware_id.value         = data.id;
    model_id.value            = data.model_id;
    status.value              = data.status;
    latest_version.value      = data.latest_version;
    ja_download_web.value     = data.ja_download_web;
    en_download_web.value     = data.en_download_web;
    file_id.value             = data.file_id;
    file_id_org.value         = data.file_id;
    direct_download_url.value = data.direct_download_url;
    file_size.value           = data.file_size;
    hash_value.value          = data.hash_value;
    release_date.value        = data.release_date;
    release_note.value        = data.release_note;

    if (status.value == 0) {
        disable_upload.value = false;
        if (file_id.value == null) {
            disable_remove.value = true;
        } else {
            disable_remove.value = false;
        }
        disable_add.value    = true;
        disable_update.value = false;
    } else {
        disable_upload.value = true;
        disable_remove.value = true;
        var res = await getFirmwareInfo({model_id: model_id.value, status: 0});
	if (res.data) {
            disable_add.value    = true;
            disable_update.value = false;
	} else {
            disable_add.value    = false;
            disable_update.value = false;
	}
    }

};

const changeModelId = async () => {
    status.value = 0;
    let res = await getFirmwareInfo({model_id: model_id.value, status: 0});
    let item = res.data;
    if (item) {
        await selectFirmwareInfo(item);
	return;
    }

    if (model_id.value == 0) {
        disable_add.value    = true;
        disable_update.value = true;
        disable_upload.value = true;
        disable_remove.value = true;
    } else {
        disable_add.value    = false;
        disable_update.value = true;
        disable_upload.value = false;
        disable_remove.value = true;
    }

    firmware_id.value         = 0;
    status.value              = 0;
    latest_version.value      = '';
    ja_download_web.value     = '';
    en_download_web.value     = '';
    file_id.value             = null;
    file_id_org.value         = null;
    direct_download_url.value = '';
    file_size.value           = '';
    hash_value.value          = '';
    release_date.value        = '';
    release_note.value        = '';
};

const bodyRowClassNameFunction = (item, index) => {
  let result = '';
  if (item.id == firmware_id.value) {
    result += 'firm-select-row';
  } else {
    result += 'firm-odd-row';
  }
  if (item.status != 0) {
    result += ' firm-in-op';
  }
  return result;
};

const keepSession = async() => {
  let res = await createSession();
  session_id.value = res.data.session_id;
  while (mounted.value) {
    let r = await updateSession(session_id.value);
    if (r.data.result != 'ok') {
      break;
    }
    await wait(20);
  }
};

onMounted( () => {
  mounted.value = true;
  keepSession();
})

onUnmounted( () => {
  mounted.value = false;
})


</script>

<style>
.app {
  font-size: 40px;
    color: blue;
}
.firm-select-row {
  --easy-table-body-row-background-color: #6cbef5;
}
.firm-odd-row {
  --easy-table-body-row-background-color: #ffffff;
}
.firm-custom {
  --easy-table-header-background-color: #9df5bc;
}
.firm-in-op {
  font-weight: bold;
}
</style>
